module.exports = __webpack_public_path__ + "origin-order2-check.eb64ea301393d946cf09.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/assets/vcg/img/origin-order2-check.svg
// module id = ../../../../../src/assets/vcg/img/origin-order2-check.svg
// module chunks = styles